function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'dark-heather': 'rgb(63, 68, 67)','mauve': 'rgb(186, 136, 136)','lilac': 'rgb(200, 162, 200)','muted-red': 'rgb(199, 106, 106)','soft-pink': 'rgb(233, 168, 178)','light-teal': 'rgb(133, 195, 198)','pale-green': 'rgb(183, 217, 160)','white-off-white': 'rgb(255, 255, 255)','bright-red': 'rgb(255, 76, 76)','taupe-brown': 'rgb(139, 106, 99)','golden-amber': 'rgb(212, 154, 74)','soft-peach': 'rgb(242, 184, 159)','cream-beige': 'rgb(234, 221, 199)','dark-taupe': 'rgb(92, 74, 64)','muted-rose': 'rgb(198, 138, 138)','golden-amber': 'rgb(212, 148, 74)','dark-brown': 'rgb(60, 44, 35)','deep-blue': 'rgb(46, 74, 125)','steel-gray': 'rgb(90, 95, 107)','olive-green': 'rgb(105, 124, 80)','soft-beige': 'rgb(222, 200, 164)','charcoal-gray': 'rgb(74, 69, 65)','forest-green': 'rgb(39, 78, 46)','earthy-brown': 'rgb(91, 72, 40)','terracotta': 'rgb(208, 138, 115)',};

    this.images = {'tan-blue-bird': 'url("//flipemthebird.com/cdn/shop/files/TanandNavy_120x.png?v=13258936594280329876")','tan-black-birds': 'url("//flipemthebird.com/cdn/shop/files/TanandBlack_120x.png?v=10824003801934445584")',};

    this.triggers = ['color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
